import Vue from "vue";
import {API_HOST} from "@/settings/server";
import $store from "@/store";
import axios from "axios";

class UserService {
    constructor() {
        this.cancelTokenSource = axios.CancelToken.source();
    }

    cancelRequests() {
        this.cancelTokenSource.cancel('GET requests canceled by the user.');
        this.cancelTokenSource = axios.CancelToken.source();
    }
    getUsers({skip, limit, inn, user, username}) {
        return Vue.axios.get(`${API_HOST}/api/User`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                limit: limit,
                skip: skip,
                inn: typeof (inn) === 'string' ? inn : null,
                userId: user,
                username: username
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }

    getUsersDynamic({inn, unitId}) {
        return Vue.axios.get(`${API_HOST}/api/User`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                inn: typeof (inn) === 'string' ? inn : null,
                unitId: unitId
            }
        })
    }

    checkUsername(username) {
        return Vue.axios.get(`${API_HOST}/api/CheckUser`, {
            params: {
                id: username
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }

    addUser({userFullName: userFullName, username, password, unit, canSignOnBehalfOfOrganization}) {
        return Vue.axios.post(`${API_HOST}/api/User`, {
            UserFullName: userFullName,
            Username: username,
            Password: password,
            UnitId: unit.id,
            CanSignOnBehalfOfOrganization: canSignOnBehalfOfOrganization
        }, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            }
        })
    }

    editUser({userFullName, username, password, unitId, canSignOnBehalfOfOrganization}) {
        return Vue.axios.put(`${API_HOST}/api/User`, {
            UserFullName: userFullName,
            Password: password,
            UnitId: unitId,
            CanSignOnBehalfOfOrganization: canSignOnBehalfOfOrganization
        }, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                id: username
            }
        })
    }
}

export default new UserService()